import React from 'react';
import Button from '../components/common/Button';

/**
 * 404 Not Found page
 */
function NotFound() {
  return (
    <div className="container mt-5 text-center animate__animated animate__fadeIn">
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Button variant="primary" onClick={() => window.location.href = '/'}>
        Go to Home
      </Button>
    </div>
  );
}

export default NotFound;